import React from 'react'
import CongratulationsContainer from './CongratulationsContainer'

const Congratulations = props => (
  <CongratulationsContainer {...props} data-test="component-stock-congratulations" />
)

export default Congratulations
